import { defineStore } from "pinia";
import service from "../service/index";
import { message } from "ant-design-vue/es";

export const useUserStore = defineStore({
  id: "user",
  state: () => ({
    name: "Eduardo",
    isLogin: false,
    cmotoken: "",
  }),

  actions: {
    setLogin(token) {
      this.$patch({
        isLogin: !!token,
        cmotoken: token,
      });
    },
    logout(router) {
      console.log("logout", router);
      service.userInfo
        .logout()
        .then(() => {
          sessionStorage.removeItem("cmotoken");
          this.$patch({
            isLogin: false,
            cmotoken: "",
          });
          router.replace({ path: "/cmo" });
        })
        .catch((error) => {
          console.log("遇到问题：", error);
          sessionStorage.removeItem("cmotoken");
          this.$patch({
            isLogin: false,
            cmotoken: "",
          });
          router.replace({ path: "/cmo" });
        });
    },
    clearUserInfo() {
      try {
        sessionStorage.removeItem("cmotoken");
        this.$patch({
          isLogin: false,
          cmotoken: "",
        });
      } catch (error) {
        console.log(error);
      }
    },
    async login(params, cb) {
      service.userInfo
        .login(params)
        .then((res) => {
          console.log(138, res);
          if (res.ok) {
            const { token } = res.data;
            sessionStorage.setItem("cmotoken", token);
            this.$patch({
              isLogin: true,
              cmotoken: token,
            });
            cb && cb();
          }
        })
        .catch((error) => {
          message.error(error.message || "登录异常");
        });
    },
  },
});
